import { MdxPage } from '@features/mdx/MdxPage';
import { LanguageEnum } from '@project-types/LanguageEnum';
import { MdxPageArticleIds } from '@features/mdx/MdxPageArticleIds';



const articleIds: MdxPageArticleIds = {
	[LanguageEnum.CZ]: '48e63367-b425-4f83-ba50-a33c4ef0d352',
	[LanguageEnum.SK]: '48e63367-b425-4f83-ba50-a33c4ef0d352',
	default: '48e63367-b425-4f83-ba50-a33c4ef0d352'
}


export const About = () => {

	return (
		<MdxPage className='about-page' articleIds={articleIds}>
		</MdxPage>
	);
};